import Spinner from "./Spiner";

function Loading(){
return <div className='relative grid'>
            <div className='absolute flex flex-col justify-self-center ' >
                <div className='flex justify-center'>
                    <Spinner/>
                </div>
            </div>
        </div>;
}
export default Loading;